import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LoggingService {
    logError(error: unknown): void {
        const timestamp = new Date().toISOString();

        if (error instanceof HttpErrorResponse) {
            console.error(`[${timestamp}] HTTP Error:`, {
                status: error.status,
                statusText: error.statusText,
                url: error.url,
                message: error.message,
                error: error.error,
            });
        } else if (error instanceof Error) {
            console.error(`[${timestamp}] Error:`, {
                name: error.name,
                message: error.message,
                stack: error.stack,
            });
        } else {
            console.error(`[${timestamp}] Unknown Error:`, error);
        }
    }

    logInfo(message: string, data?: any): void {
        const timestamp = new Date().toISOString();
        console.info(`[${timestamp}] ${message}`, data);
    }

    logWarning(message: string, data?: any): void {
        const timestamp = new Date().toISOString();
        console.warn(`[${timestamp}] ${message}`, data);
    }
}
